// ref: https://cursos.alura.com.br/forum/topico-duvida-routereusestrategy-e-onsameurlnavigation-deprecated-273967

// classe para fazer a mesma função de: this.router.routeReuseStrategy.shouldReuseRoute = () => false;
// essa função foi marcada como deprecated
// 

import {ActivatedRouteSnapshot, BaseRouteReuseStrategy} from '@angular/router';

export class CustomReuseStrategy extends BaseRouteReuseStrategy {

  public override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.data['reuseComponent'];
  }
}